import { LegalLayout, LegalSection } from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" updated="September 2026" testId="terms-page">
      <LegalSection heading="1. Agreement">
        <p>
          These Terms of Service govern your use of brandijo.com (the "Site"), operated by Brandi Jo
          Newman / 7671 Enterprises ("we," "us"). By using the Site, purchasing a digital product, or
          engaging coaching services, you agree to these terms. If you do not agree, please do not use
          the Site.
        </p>
      </LegalSection>
      <LegalSection heading="2. Services and Digital Products">
        <p>
          The Site offers informational content, coaching services, and digital products (such as
          downloadable guides and journals). Digital products are delivered electronically. All content
          is for personal, non-commercial use and may not be reproduced, resold, or distributed without
          written permission.
        </p>
      </LegalSection>
      <LegalSection heading="3. No Professional Advice">
        <p>
          Content, coaching, and digital products are provided for educational and informational purposes
          only. They are not medical, psychological, legal, financial, or tax advice. Always consult a
          qualified professional for advice specific to your situation. Results vary by individual, and no
          specific outcome is guaranteed.
        </p>
      </LegalSection>
      <LegalSection heading="4. Purchases and Refunds">
        <p>
          Prices are shown at checkout in U.S. dollars. Where a money-back guarantee is offered for a
          digital product, its terms are stated on the product's sales page. To request a refund under an
          applicable guarantee, email <a href="mailto:me@brandijo.com" className="underline hover:text-brand-gold transition-colors">me@brandijo.com</a> within
          the stated period. Coaching engagements are governed by their individual agreements.
        </p>
      </LegalSection>
      <LegalSection heading="5. Text Messaging">
        <p>
          Where the Site invites you to text us or opt into text messages, you will only receive messages
          you requested. Message and data rates may apply. Reply STOP to end and HELP for help. Consent to
          receive texts is never a condition of any purchase.
        </p>
      </LegalSection>
      <LegalSection heading="6. Intellectual Property">
        <p>
          All Site content, including text, design, graphics, and digital products, is owned by Brandi Jo
          Newman / 7671 Enterprises and protected by applicable intellectual property laws.
        </p>
      </LegalSection>
      <LegalSection heading="7. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, we are not liable for any indirect, incidental, or
          consequential damages arising from your use of the Site, products, or services. Our total
          liability for any claim will not exceed the amount you paid us in the twelve months preceding
          the claim.
        </p>
      </LegalSection>
      <LegalSection heading="8. Third-Party Links">
        <p>
          The Site links to third-party websites and services we do not control. We are not responsible
          for their content or practices. Some links may be affiliate links, which are disclosed where
          they appear.
        </p>
      </LegalSection>
      <LegalSection heading="9. Changes and Contact">
        <p>
          We may update these terms from time to time; the "Last updated" date reflects the current
          version. Continued use of the Site constitutes acceptance. Questions:{" "}
          <a href="mailto:me@brandijo.com" className="underline hover:text-brand-gold transition-colors">me@brandijo.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
